import { PropTypes } from "prop-types";
import Marquee from "react-fast-marquee";
import "@/css/announcement-bar.scss";

const AnnouncementBar = ({ content }) => {
  return (
    <div className="z-header bg-dark-green text-white">
      <div className="leadig-none py-2 text-center text-sm leading-none overflow-hidden w-full">
        <div className="announcement-bar__marquee-wrapper overflow-hidden">
          <Marquee autoFill={true} speed={20}>
            <div
              className="announcement-bar__content mx-6 lg:mx-10 xl:mx-24"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </Marquee>
        </div>
      </div>
    </div>
  );
};

      AnnouncementBar.propTypes = {
        visible: PropTypes.bool,
      content: PropTypes.string,
};

      export default AnnouncementBar;
